import React from "react";
import { Link } from "react-router-dom";
import "../css/returns.scss";

function Returns() {
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <main className="returns-page" aria-labelledby="returns-title">
      <div className="policy-inner">
        <header className="policy-intro">
          <p className="policy-eyebrow">Shop policies · 02</p>
          <h1 id="returns-title">returns &amp; exchanges</h1>
          <p className="policy-deck">
            If something about your order needs attention, please write to us before
            sending it back.
          </p>
        </header>

        <div className="policy-list">
          <section className="policy-section" aria-labelledby="return-contact">
            <span className="policy-number" aria-hidden="true">01</span>
            <div className="policy-section-copy">
              <h2 id="return-contact">Start with a message</h2>
              <p>
                Email <a href="mailto:service@pmistpearl.work">service@pmistpearl.work</a>
                {" "}with any question or concern about your order. Including the order
                details and a short note about the issue will help us understand your
                request.
              </p>
            </div>
          </section>

          <section className="policy-section" aria-labelledby="return-authorization">
            <span className="policy-number" aria-hidden="true">02</span>
            <div className="policy-section-copy">
              <h2 id="return-authorization">Authorization is required</h2>
              <p>
                Please wait for a reply before mailing anything back. pmistpearl does
                not accept returns that have not been authorized in advance.
              </p>
            </div>
          </section>
        </div>

        <aside className="policy-contact" aria-label="Returns contact information">
          <p className="policy-contact-label">Need a hand?</p>
          <p>
            Write to <a href="mailto:service@pmistpearl.work">service@pmistpearl.work</a>
            <br />
            For timing and carrier details, see our {" "}
            <Link to="/shipping" onClick={toTop}>shipping &amp; delivery policy</Link>.
          </p>
        </aside>
      </div>
    </main>
  );
}

export default Returns;
